module.exports = __webpack_public_path__ + "static/img/echart4.2ad104d9.png";